import { Entity, EntityMeta } from '@backstage/catalog-model';
import { generateAjvJsonSchemaValidator } from '../utils';
import schema from '../schema/ReverseProvisioningTemplate.v1alpha1.schema.json';
import { JsonObject } from '@backstage/types';

export const ReverseProvisioningTemplateFileName =
  'reverse-provisioning-template.yaml';
declare interface ReverseProvisioningTemplateEntity extends Entity {
  /**
   * v2 enables support for skeleton entities"
   */
  apiVersion: 'witboost.com/v1' | 'witboost.com/v2';
  kind: 'ReverseProvisioningTemplate';
  metadata: EntityMeta;
  spec: {
    owner?: string;
    domain?: string;
    /**
     * witboost use case template references
     */
    useCaseTemplateRef?: string[];
    /**
     * Use Case Template Ids
     */
    useCaseTemplateId?: string[];
    /**
     * JSONSchemas which is used to render a form in the frontend
     * to collect user input and validate it against that schema.
     */
    parameters?: JsonObject;
    /**
     * Compatibility settings
     */
    compatibility?: {
      /**
       * (backward) Compatibility settings for legacy entities used when `apiVersion` is `witboost.com/v2`
       */
      legacyEntities?: {
        /**
         * Whether the reverse provisioning operation can be performed with this template on legacy entities
         */
        executionPolicy?: 'ALLOWED' | 'NOT_ALLOWED';
      };
      /**
       * (forward) Compatibility settings for skeleton entities used when `apiVersion` is `witboost.com/v1`
       */
      skeletonEntities?: {
        /**
         * Whether the reverse provisioning operation can be performed with this template on skeleton entities
         */
        executionPolicy?: 'ALLOWED' | 'ALLOWED_WITH_WARNING' | 'NOT_ALLOWED';
        /**
         * Used in case of legacy reverse provisioning updates targeting catalog info fields. If set to true, updates that cannot be mapped to a skeleton parameter (e.g., through `pathToParameterMap`) will be saved as skeleton overrides.
         */
        saveCatalogInfoUpdatesAsOverrides?: boolean;
        /**
         * Used to map legacy reverse provisioning updates (targeting catalog info fields) to skeleton parameter updates
         */
        pathToParameterMap?: Record<string, string>;
      };
    };
  };
}

export type { ReverseProvisioningTemplateEntity as ReverseProvisioningTemplate };

export const reverseProvisioningTemplateEntityV1alpha1Validator =
  generateAjvJsonSchemaValidator(schema);
